import React from 'react';
import { Heart, Instagram, Facebook, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';
import WeddingCountdown from './Countdown';

const Footer = () => {
  const { language } = useLanguage();
  const content = weddingData[language].footer;

  return (
    <footer className="bg-gradient-to-b from-lilac-50 to-ivory border-t border-lilac-200">
      {/* Countdown Section */}
      <div className="section-lilac-gradient py-10 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center space-y-4 sm:space-y-6">
            <Clock className="text-gold-500 w-7 h-7 sm:w-8 sm:h-8" />
            <p className="text-plum-700 font-montserrat text-sm sm:text-base lg:text-lg text-center">
              {language === 'fr' ? 'Plus que' : 'Countdown to'} <span className="font-semibold">14 août 2026</span>
            </p>
            <WeddingCountdown showTitle={false} />
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="flex flex-col items-center space-y-6 sm:space-y-8">
          {/* Names & Date */}
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-playfair font-bold text-plum-900 mb-2">
              Nelly <span className="text-gold-500">&</span> Cyrille
            </h3>
            <p className="text-plum-600 font-montserrat text-sm sm:text-base">
              14 août 2026 · Abidjan
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4 sm:gap-6">
            <a
              href="#"
              className="p-3 sm:p-3.5 rounded-full bg-white shadow-soft hover:shadow-gold hover:bg-gold-50 
                       transition-all duration-300 text-plum-600 hover:text-gold-600"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a
              href="#"
              className="p-3 sm:p-3.5 rounded-full bg-white shadow-soft hover:shadow-gold hover:bg-gold-50 
                       transition-all duration-300 text-plum-600 hover:text-gold-600"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a
              href="mailto:cyrilleneninbi@gmail.com"
              className="p-3 sm:p-3.5 rounded-full bg-white shadow-soft hover:shadow-gold hover:bg-gold-50 
                       transition-all duration-300 text-plum-600 hover:text-gold-600"
              aria-label="Email"
            >
              <Mail className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
          </div>

          {/* Copyright */}
          <div className="flex items-center gap-2 text-plum-600 text-xs sm:text-sm font-montserrat">
            <span>{content.text}</span>
            <Heart className="w-4 h-4 text-gold-500 fill-gold-500 animate-pulse" />
          </div>

          {/* Made With */}
          <p className="text-[11px] sm:text-xs text-plum-500/70 font-montserrat">
            {content.madeWith}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
